import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsGeneratorModule } from '../inputs-generator/inputs-generator.module';
import { InputAddressComponent } from './input-address.component';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [InputAddressComponent],
  imports: [CommonModule, InputsGeneratorModule, FormsModule, DirectivesModule],
})
export class InputAddressModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(InputAddressComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-input-address', customComponent);
  }
}
